import { styled } from 'styled-components'

export const MenuItemWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 0 0 50%;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background-color: ${props => (props.isPressed ? props.theme.color.pressed : 'transparent')};

  &:nth-child(even):before {
    position: absolute;
    top: 2rem;
    bottom: 2rem;
    left: 0;
    width: 1px;
    background-color: ${props => props.theme.color.line};
    content: '';
  }
  &:not(:nth-last-child(-n + 2)):after {
    position: absolute;
    bottom: 0;
    left: 2rem;
    right: 2rem;
    height: 1px;
    background-color: ${props => props.theme.color.line};
    content: '';
  }
`

export const MenuItemImage = styled.div`
  width: 80%;
  max-width: 220px;
  height: 220px;
  object-fit: cover;
  margin-bottom: 20px;
`

export const MenuItemTitle = styled.h5`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0.75rem;
`

export const MenuItemPrice = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 22px;
  color: ${props => props.theme.color.primary};
  margin-bottom: 1rem;
`
